// CalendarApprovalBanner — Jul 2026 (Randy 2B). Shows on the silo manage page
// of PERSONAL silos when calendar items are waiting in the approval inbox.
import { useEffect, useState } from "react";
import { Bell, CaretRight } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export default function CalendarApprovalBanner({ silo, onOpen }) {
  const [inbox, setInbox] = useState(null);

  useEffect(() => {
    if (!silo?.id || silo.silo_kind !== "personal") return;
    let alive = true;
    const load = () =>
      api.get(`/calendar/${silo.id}/inbox`)
        .then((r) => { if (alive) setInbox(r.data); })
        .catch(() => { /* locked / no calendar — stay silent */ });
    load();
    window.addEventListener("mysilo:calendar-refresh", load);
    return () => { alive = false; window.removeEventListener("mysilo:calendar-refresh", load); };
  }, [silo?.id, silo?.silo_kind]);

  if (!inbox || !inbox.count) return null;
  const n = inbox.count;
  return (
    <button
      onClick={() => { onOpen(); window.dispatchEvent(new Event("mysilo:open-approval-inbox")); }}
      data-testid="calendar-approval-banner"
      className="w-full mb-6 flex items-center gap-3 text-left px-4 py-3 rounded-lg border border-[#C19A4A] bg-[#F8F1E2] hover:bg-[#F3E7CB] transition-colors"
    >
      <Bell size={18} weight="duotone" className="text-[#8A6A24] shrink-0" />
      <span className="flex-1 text-sm text-[#1C1B1A]">
        {inbox.is_owner
          ? <><strong>{n} calendar item{n === 1 ? "" : "s"}</strong> waiting for your approval.</>
          : <>You have <strong>{n} item{n === 1 ? "" : "s"}</strong> waiting for the calendar owner's approval.</>}
      </span>
      <span className="text-xs text-[#8A6A24] flex items-center gap-0.5 shrink-0">Review <CaretRight size={12} weight="bold" /></span>
    </button>
  );
}
